import React, { useState, useEffect } from 'react';
// import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Line } from '@ant-design/charts';


const DemoLine = () => {
  const [data, setData] = useState([
    {
      "Year": "2020-01",
      "scales": 0
    },
    {
      "Year": "2020-07",
      "scales": 600
    },
    {
      "Year": "2021-01",
      "scales": 800
    },
    {
      "Year": "2021-07",
      "scales": 1000
    },
    {
      "Year": "2022-01",
      "scales": 1500
    },
    {
      "Year": "2022-07",
      "scales": 3800
    },
    {
      "Year": "2023-01",
      "scales": 7400
    },
    {
      "Year": "2023-07",
      "scales": 9600
    },
    {
      "Year": "2023-10",
      "scales": 10800
    },
    {
      "Year": "2023-12",
      "scales": 12500
    },
    {
      "Year": "2024-01",
      "scales": 15500
    },//   Anzac Project, no construction
    {
      "Year": "2024-02",
      "scales": 16500
    },//  Diamond Project, no construction
    {
      "Year": "2024-03",
      "scales": 17500
    },//  Arthur Project, no construction
    {
      "Year": "2024-04",
      "scales": 19800
    },//  Marion Project, add construction
    {
      "Year": "2024-05",
      "scales": 21800
    },//  Pooraka, Valley View, no construction
    {
      "Year": "2024-06",
      "scales": 23800
    },//  Gilles Plains construction, #5 Gepps Cross, no construction
    {
      "Year": "2024-07",
      "scales": 26600
    },//  Mobury Heights, Clearview
    {
      "Year": "2024-08",
      "scales": 27800
    },//  Marden
    {
      "Year": "2024-09",
      "scales": 28600
    },//  Christy Down
    {
      "Year": "2024-10",
      "scales": 29400
    },//  Ingle Farm
    {
      "Year": "2024-11",
      "scales": 30000
    },//  Christy Down, 3 Antony
    {
      "Year": "2024-12",
      "scales": 32100
    },//  Vista, Morphett, Raynella
    {
      "Year": "2025-01",
      "scales": 36600
    },//  Investment, 21 Construction
    {
      "Year": "2025-02",
      "scales": 37100
    },//  Investment
    {
      "Year": "2025-03",
      "scales": 37800
    },//  49 Graham
    {
      "Year": "2025-04",
      "scales": 39300
    },//  13 Church
    {
      "Year": "2025-05",
      "scales": 40500
    },//  Trust
    {
      "Year": "2025-06",
      "scales": 41500
    },//  3 Parslow
    {
      "Year": "2025-07",
      "scales": 42500
    },//  3 Parslow, 8 Leabrook Drive
    {
      "Year": "2025-08",
      "scales": 45500
    },//  23, 31, 5 Tepko Construction
    {
      "Year": "2025-09",
      "scales": 47700
    },//  6 Perkins, 30 Constrctuion
  ]);

  const config = {
    data,
    padding: 'auto',
    xField: 'Year',
    yField: 'scales',
    color: '#C69852',
    point: {
      size: 5,
      shape: 'diamond',
      style: {
        fill: 'white',
        stroke: '#C69852',
        lineWidth: 2,
      },
    },
    smooth: true,
    xAxis: {
      // type: 'timeCat',
      tickCount: 5,
    },
    yAxis: {
      label: {
        formatter: (v) => {
          if (v >= 1000) {
            return `$ ${(v / 1000).toFixed(1)} M`; // Converts thousands to millions and formats it to one decimal place
          } else {
            return `$ ${v} K`;
          }
        },
      },
    },
  };

  const chartStyle = {
    width: '100%',
    height: '100%',
    margin: '0',
  };

  return (
    <div style={chartStyle}>
      <Line {...config} />
    </div>
  );
};


export default DemoLine;